import { gql } from "@apollo/client";

export const customBlocksQuery = gql`
  query customBlocks($scenarioId: ID!) {
    data(scenarioId: $scenarioId) {
      customBlocks {
        start
        end
      }
    }
  }
`;
